"use client";

import { usePathname } from "next/navigation";
import { useLayoutEffect, useRef } from "react";
import { isReloadBlocked } from "./reload-blockers";
import { workspaceAreaOf } from "./workspace-area";

/** Stale build: next area switch becomes a full reload. Layout effect runs before the new area's mutations fire. */
export function useReloadOnAreaChange(active: boolean): void {
  const area = workspaceAreaOf(usePathname());
  const lastAreaRef = useRef(area);

  useLayoutEffect(() => {
    const previous = lastAreaRef.current;
    lastAreaRef.current = area;
    if (!active || area === previous) return;
    if (isReloadBlocked()) return;
    window.location.reload();
  }, [active, area]);
}
